import Message from './src/message';

module.exports = Message;


// WEBPACK FOOTER //
// ./src/components/message/index.js